import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Spinner,
} from "@fluentui/react-components";
import { DeleteDismissFilled } from "@fluentui/react-icons";
import { toast } from "components/FluentToast";
import { VSpace } from "components/Spacer";
import React from "react";
import { useTranslation } from "react-i18next";
import { useImportedInvoicesStore } from "store/ImportedInvoicesStore";

// Deletes one invoice or every ticked invoice (importedInvoiceIds) in one request;
// the rows disappear from the list on success.
export const DeleteImportedInvoiceDialog = () => {
  const [
    { deleteImportedInvoiceDialog, deleteImportedInvoiceStatus },
    {
      setImportedInvoicesStoreValue,
      setImportedInvoicesStoreValues,
      deleteImportedInvoices,
      removeImportedInvoices,
    },
  ] = useImportedInvoicesStore();

  const isLoading = deleteImportedInvoiceStatus === "loading";
  const { t } = useTranslation();
  const ids: number[] = deleteImportedInvoiceDialog.importedInvoiceIds ?? [];
  const isMany = ids.length > 1;

  return (
    <Dialog open={deleteImportedInvoiceDialog.isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            {isMany
              ? t("pct.deleteImportedInvoicesSelected.label", { n: ids.length })
              : t("pct.deleteImportedInvoice.label")}
          </DialogTitle>
          <DialogContent>
            {isMany
              ? t("pct.deleteImportedInvoicesSelectedConfirm.label", { n: ids.length })
              : t("pct.deleteImportedInvoiceConfirm.label")}
            <VSpace height={20} />
          </DialogContent>
          <DialogActions>
            <Button
              appearance="secondary"
              disabled={isLoading}
              onClick={() => {
                setImportedInvoicesStoreValue("deleteImportedInvoiceDialog", {
                  isOpen: false,
                  importedInvoiceIds: [],
                });
              }}
            >
              {t("pct.close.label")}
            </Button>
            <Button
              data-help="imported-invoices-delete-confirm"
              appearance="primary"
              disabled={isLoading || ids.length === 0}
              icon={
                isLoading ? (
                  <Spinner size="tiny" />
                ) : (
                  <DeleteDismissFilled fontSize={16} />
                )
              }
              onClick={() => {
                deleteImportedInvoices({ importedInvoiceIds: ids }, () => {
                  setImportedInvoicesStoreValues({
                    deleteImportedInvoiceDialog: {
                      isOpen: false,
                      importedInvoiceIds: [],
                    },
                  });
                  toast.success(t("greco.success"));
                  removeImportedInvoices(ids);
                });
              }}
            >
              {t("pct.delete.label")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
